export var EntityType;
(function (EntityType) {
    EntityType["EVENT"] = "EVENT";
    EntityType["VENUE"] = "VENUE";
    EntityType["VENDOR"] = "VENDOR";
    EntityType["USER"] = "USER";
    EntityType["PHOTO"] = "PHOTO";
    EntityType["EXPENSE"] = "EXPENSE";
    EntityType["DOCUMENT"] = "DOCUMENT";
    EntityType["VENDOR_CATEGORY"] = "VENDOR_CATEGORY";
})(EntityType || (EntityType = {}));
/** Standard link types */
export var LinkType;
(function (LinkType) {
    LinkType["CONTACT"] = "CONTACT";
    LinkType["TAG"] = "TAG";
    LinkType["ASSIGNMENT"] = "ASSIGNMENT";
    LinkType["OPERATOR"] = "OPERATOR";
    LinkType["CATEGORY"] = "CATEGORY";
    LinkType["CLIENT"] = "CLIENT";
    LinkType["VENDOR"] = "VENDOR";
})(LinkType || (LinkType = {}));
//# sourceMappingURL=entity-link.js.map